import { BaseCompany } from './company';

export interface BaseUser {
  [key: string]: any;
  uuid: string;
}

export interface User extends BaseUser {
  id: string;
  first_name: string;
  last_name: string;
  status: string;
  email: string;
  username: string;
  is_active: boolean;
  language: string;
  role: Role;
  date_joined?: string;
  last_login?: string;
  created_at?: string;
  updated_at?: string;
  company: BaseCompany;
  trial_has_expired: boolean;
  num_days_until_trial_expiration_date: number;
  trial_expiration_date?: string;
  onboarding_status: string;
  companies?: BaseCompany[];
}

export enum Role {
  User = 'user',
  ClientAdmin = 'client_admin',
  Admin = 'super_admin',
}

export enum Status {
  STATUS_PENDING = 'pending',
  STATUS_ACTIVE = 'active',
  STATUS_EMAIL_PENDING = 'email_pending',
  STATUS_DISABLED = 'disabled',
  STATUS_INACTIVE = 'inactive',
}
